import { TableName } from '@/enums/tableName.enum';
import store from '@/store/store';
import TeamSchedules from '@/views/team/tabs/Schedules.vue';

export const teamSchedulesRoute = {
  path: '',
  name: 'teamSchedules',
  component: TeamSchedules,
  meta: { title: 'titles.team.schedules' },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('schedule/setEntityType', TableName.Team);
    store.commit('schedule/setEntityId', to.params.teamId.toString());
    next();
  }
};
